import React from 'react';
import { Reveal } from './Reveal';
const modules = [{
  n: '01',
  icon: '🧭',
  title: 'Cómo funciona la quema de grasa',
  text: 'Entendé qué pasa en tu cuerpo cuando caminás, por qué el metabolismo se activa y cuáles son los errores más comunes que frenan tus resultados sin que lo sepas'
}, {
  n: '02',
  icon: '👟',
  title: 'Técnica, postura y paso eficiente',
  text: 'Aprendé a caminar de la forma correcta para maximizar la quema de calorías en cada salida, cuidar tus rodillas y columna, y evitar lesiones que te hagan parar'
}, {
  n: '03',
  icon: '❤️',
  title: 'Frecuencia cardíaca y zonas de quema',
  text: 'Descubrí en qué zona de ritmo cardíaco el cuerpo usa la grasa como combustible principal, cómo medirlo sin equipos caros y cómo usarlo a tu favor'
}, {
  n: '04',
  icon: '📆',
  title: 'Planificación semanal inteligente',
  text: 'Cómo organizar tus caminatas durante la semana según tu ritmo de vida, cómo ir aumentando la intensidad sin agotarte y cómo no perder el hábito'
}, {
  n: '05',
  icon: '🥦',
  title: 'Nutrición que potencia cada paso',
  text: 'Qué comer antes y después de caminar, qué hábitos alimenticios hacen la diferencia real, y cómo combinar caminata y nutrición sin pasar hambre ni privarte'
}, {
  n: '06',
  icon: '🧠',
  title: 'Mentalidad, progreso y constancia',
  text: 'Cómo superar las mesetas, qué hacer cuando no tenés ganas, cómo medir tus avances reales y cómo convertir la caminata en un hábito de por vida'
}];
export function Modules() {
  return <section className="w-full bg-cream" data-id="element-119" data-mp="368ro3bom4v3e">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-120" data-mp="369t1hmt3ptoa">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="31azk3jap1iiu">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-122" data-mp="318dehp7d5d39">
            6 Módulos de puro conocimiento
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-123" data-mp="2rbqs2vze2dz4">
            Todo lo que necesitás saber para transformar tu cuerpo caminando,
            organizado de forma clara y progresiva.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-124" data-mp="2moixh9ckeann">
          {modules.map((m, i) => <Reveal key={m.n} delay={i % 2 * 0.08} data-id="element-125" data-mp="28p1ghg5ig1ou" data-mpi={i}>
              <div className="flex h-full gap-5 rounded-2xl border border-ink/10 bg-white p-6 shadow-sm" data-id="element-126" data-mp="2cp1w344ciixh">
                <div className="flex-shrink-0" data-id="element-127" data-mp="30f5vezai3wio">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-brand-light text-2xl" data-id="element-128" data-mp="30ffnqtj0qfrj">
                    {m.icon}
                  </div>
                </div>
                <div data-id="element-129" data-mp="2rlsupb673qm1">
                  <span className="text-sm font-bold text-brand" data-id="element-130" data-mp="2rkhv7njs950q">{m.n}</span>
                  <h3 className="mt-1 text-lg font-bold text-ink" data-id="element-131" data-mp="2vmmlqdexplj5">{m.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-132" data-mp="3jcpbgmvdmfel">{m.text}</p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}